import { render, staticRenderFns } from "./fillPreQuiz2.vue?vue&type=template&id=2c234304&scoped=true"
import script from "./fillPreQuiz2.vue?vue&type=script&lang=js"
export * from "./fillPreQuiz2.vue?vue&type=script&lang=js"
import style0 from "./fillPreQuiz2.vue?vue&type=style&index=0&id=2c234304&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c234304",
  null
  
)

export default component.exports